import React from 'react'
import { Spinner, SpinnerBlue, SpinnerGreen, SpinnerRed } from './LeftDiv'
import { MainButton, MilestoneContainer, MilestoneDescription, NewListingBody, NewListingCont, TallFiltersCont } from '../Styles'
import { currentWebsiteURL } from '../data/config'
import { addPermission } from '../data/functions/permission_functions'
import { useStateContext } from '../contexts/ContextProvider'


const AddPermissionPage = () => {
    const {
        enterModalText,
        setEnterModalText,
        loadingDisplay,
        setLoadingDisplay,
        setEnterButtonsDisplay,
        enterModalDisplay,
        setEnterModalDisplay,
      } = useStateContext();

  return (
    // <div style={{textAlign:"center", height:"100vh", paddingTop:"100px", width:"100vw"}}>
    <NewListingCont>
        <NewListingBody>
            <TallFiltersCont>
                <h2>Create Listing</h2>
            </TallFiltersCont>
        
        <MilestoneContainer>
            <MilestoneDescription>
            In order to create a listing, you first need to give us permission to create{" "}
        new accounts on your behalf (for details regarding these permissions, check the <a href={`${currentWebsiteURL}/faq`}>FAQ page</a>)
        <br/><br/>
        NOTE: You must have the "Allow Dangerous Transactions" setting enabled in Anchor wallet.
            </MilestoneDescription>
        </MilestoneContainer>
        
        <TallFiltersCont>
            <div className='w-100 text-center items-center justify-center mt-2'>
                <MainButton
                    onClick={() => {
                        addPermission(setEnterModalText, setLoadingDisplay, setEnterButtonsDisplay, setEnterModalDisplay)                        
                    }}
                >
                Add Permission
                </MainButton>                
            </div>
        </TallFiltersCont>
        </NewListingBody>
    </NewListingCont>
  

    // </div>
  )
}

export default AddPermissionPage